// extracted by mini-css-extract-plugin
module.exports = {"gallery":"Gallery-module--gallery--OA28n","image":"Gallery-module--image--1pB7k"};